import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { CheckCircle2, Download, Gift } from 'lucide-react';
import { motion } from 'framer-motion';
export function EbookSection() {
  return <Section background="green" className="text-white relative overflow-hidden" data-id="element-953">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full blur-3xl" data-id="element-954"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#D4AF37]/10 rounded-full blur-3xl" data-id="element-955"></div>
    </Section>;
}